import React, { FC } from 'react'
import { getDateString } from '../../../lib/utils'

import css from './Date.module.scss'

interface IDate {
  dateString: string
}

const DateString: FC<IDate> = ({ dateString }) => {
  return <p className={css.date}>{getDateString(new Date(dateString))}</p>
}

export default DateString
